export default __webpack_public_path__ + "static/media/womanSittingError.4da07b86.svg";